export default "__VITE_ASSET__DeEXbmTR__"